var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChrome = function SvgChrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 45"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Chrome_svg__a",
    width: 45,
    height: 45,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h45v45H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    mask: "url(#Chrome_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Chrome_svg__b)",
    d: "M22.502 31.29a8.79 8.79 0 1 1 0-17.58 8.79 8.79 0 0 1 0 17.58m0-29.972C10.804 1.318 1.32 10.802 1.32 22.5c0 11.698 9.484 21.182 21.182 21.182 11.698 0 21.182-9.484 21.182-21.182 0-11.698-9.484-21.182-21.182-21.182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.71h19.277M30.055 26.993l-9.578 16.591M14.824 26.783 5.25 10.202M22.5 31.29a8.79 8.79 0 1 1 0-17.58 8.79 8.79 0 0 1 0 17.58"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Chrome_svg__b",
    x1: 1.32,
    x2: 43.684,
    y1: 43.682,
    y2: 1.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })))));
};
export default SvgChrome;